import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { Device } from '@capacitor/device';
import { STORAGE_KEYS } from '@/shared/constants/app';
import storageService from '@/shared/services/storage.service';

const getOrCreateInstallationId = async () => {
  const key = STORAGE_KEYS.PUSH_INSTALLATION_ID;

  const value = await storageService.getItem(key);
  if (value) return value;

  const newId = crypto.randomUUID();
  await storageService.setItem(key, newId);
  return newId;
};

// Called by the serialized native push-session workflow after permission is granted.
export const getPushSubscriptionPayload = async (fcmToken) => {
  if (!fcmToken) {
    return null;
  }

  const installationId = await getOrCreateInstallationId();
  const platform = Capacitor.getPlatform();

  const [appInfo, info, id, language] = await Promise.all([
    App.getInfo(),
    Device.getInfo(),
    Device.getId(),
    Device.getLanguageTag(),
  ]);

  const deviceInfo = {
    identifier: id?.identifier || null,
    model: info?.model || null,
    platform,
    operatingSystem: info?.operatingSystem || null,
    osVersion: info?.osVersion || null,
    manufacturer: info?.manufacturer || null,
    isVirtual: info.isVirtual,
    webViewVersion: info?.webViewVersion || null,
    languageCode: language.value.split('-')[0],
  };

  return {
    installationId,
    platform,
    fcmToken,
    appVersion: appInfo?.version || null,
    appBuildVersion: appInfo?.build || null,
    appId: appInfo?.id || null,
    deviceInfo,
  };
};
